// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3KtFc","row":"Node_row__TcaqR","label":"Node_label__3z5tZ","footer":"Node_footer__Oj0Kq"};